import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeItem } from "../redux/cartListSlice";
import "./Cart.css";
import { useNavigate } from "react-router-dom";
import CartItem from "./CartItem";
import { setOrderNumber } from "../redux/orderNumberSlice";

function useForceUpdate() {
  const [val, setVal] = useState(0);
  return () => setVal((prevVal) => prevVal + 1);
}

function Cart() {
  const [cartItemsData, setCartItemsData] = useState([]);
  const cartItems = useSelector((state) => state.cartList);

  const dispatch = useDispatch();
  const forceUpdate = useForceUpdate();
  const navigate = useNavigate();

  const token = useSelector((state) => {
    return state.token;
  });
  const tokenBearer = token.token;

  const getAndSetItemsData = async (cartItems) => {
    const itemsData = [];

    if (!cartItems.length) {
      setCartItemsData([]);
      return;
    }

    for (const item of cartItems) {
      try {
        if (!item.slug) continue;

        const data = await axios

          // TODO: env variables
          .get(`${process.env.REACT_APP_API_URL}/products/` + item.slug)
          .then((res) => res.data);

        if (!data) continue;

        itemsData.push({ ...data, quantity: item.quantity });
      } catch (err) {
        console.log(err);
      }
    }
    // console.log(itemsData);
    setCartItemsData(itemsData);
  };

  const handleOnItemRemove = (slug) => {
    // console.log(slug);
    dispatch(removeItem({ slug }));
    forceUpdate();
  };

  useEffect(() => {
    getAndSetItemsData(cartItems);
  }, []);

  useEffect(() => {
    getAndSetItemsData(cartItems);
  }, [cartItems]);

  useEffect(() => {
    // console.log(cartItemsData);
  }, [cartItemsData]);

  const handleCheckOut = async (e) => {
    e.preventDefault();

    if (!tokenBearer) {
      navigate("/login?from=checkout");
    }

    try {
      const authAxios = axios.create({
        baseURL: `${process.env.REACT_APP_API_URL}/private/order`,
        headers: {
          Authorization: `Bearer ${tokenBearer}`,
          ContentType: `application/json`,
        },
      });
      const response = await authAxios.post(
        `${process.env.REACT_APP_API_URL}/private/order`,
        { cart: cartItems }
      );
      // console.log(cartItems);
      // console.log(response.data._id);
      dispatch(setOrderNumber(response.data._id));
      navigate("/checkout");
    } catch (err) {
      // console.log(err.data);
    }
  };

  return (
    <div className="container">
      <h1 className="text-center  mt-50 mb-60">Cart</h1>
      <div className="row p-0 m-0">
        <div className="col-12 p-0 m-0">
          {cartItemsData.map((item) => (
            <CartItem
              key={item.slug}
              onItemRemove={() => handleOnItemRemove(item.slug)}
              data={item}
            />
          ))}
        </div>
      </div>
      {cartItems.length ? (
        <div className="d-flex flex-column align-items-start my-5 ">
          <p className="fs-3 mb-2 p-0 m-0">
            Total: $
            {cartItemsData
              .reduce((prev, cur) => prev + cur.price * cur.quantity, 0)
              .toFixed(2)}
          </p>
          <button
            className="btn mt-3 mb-5"
            type="submit"
            style={{
              backgroundColor: `rgb(213, 179, 117)`,
              fontFamily: `Corporate S Regular, sans-serif`,
              color: `white`,
            }}
            onClick={(e) => {
              handleCheckOut(e);
            }}
          >
            Checkout
          </button>
        </div>
      ) : (
        <p className="fs-4 py-5 my-5">No items in cart</p>
      )}
    </div>
  );
}

export default Cart;
